module.exports = __webpack_public_path__ + "static/media/Local_FnF_introduction_video.0d9e0149.mp4";